import type { ReactElement } from "react";
import { Navbar as OliNavbar } from "@olivahealth/oli-ui";
import useTranslation from "../../../hooks/useTranslation";
import { useUserData } from "../../../services/contexts/UserDataContext";
import useNavbar from "./useNavbar";

interface NavbarProps {
  variant: "light" | "dark";
}

export default function Navbar({ variant }: NavbarProps): ReactElement | null {
  const { data: userData } = useUserData();
  const {
    data: { isOrganisationAdmin, links },
  } = useNavbar();
  const { t } = useTranslation("common", { keyPrefix: "navbar" });

  if (!links || links.length === 0) {
    return null;
  }

  return (
    <OliNavbar
      isOrganisationAdmin={isOrganisationAdmin}
      hasTeamSessionsOnly={userData?.organisation?.hasTeamSessionsOnly ?? false}
      labels={{
        admin: t("labels.admin"),
        company: t("labels.company"),
      }}
      links={links}
      variant={variant}
    />
  );
}
